module.exports = __webpack_public_path__ + "img/container-storage.c433fbb6.svg";